<p>
  calendar-metadata-editor works!
</p>
